/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPhoneSmartIcon16Solid = forwardRef('TechPhoneSmartIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 1A2.5 2.5 0 0 1 13 3.5v9a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 2 12.5v-9A2.5 2.5 0 0 1 4.5 1h6Zm-6 11.5A.5.5 0 0 1 5 12h5a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5ZM5 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" })));
});
